/* @flow */

export default {
  ROW_HEIGHT: 26,
  BLOCK_GAP: 12,
  INPUT_DEFAULT_SIZE: 25,
};
